export const tier360MedallionLabel = 'Delta 360° ™';
export const SkyMilesMemberLabel = 'SkyMiles® Member';
export const ThankYouMessageLabel = 'Thank you for being a ';
export const MilesAvailableLabel = 'Miles Available';
export const TodayLabel = 'Today';
export const MyFlightLabel = 'My Skymiles';
